/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import inventoryFormStyles from "./InventoryForm.styles";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { BUTTON_LABELS, INPUT_LABELS } from "../../constants/lang";
import TextFeild from "../../components/CommonComponents/TextFeild";
import Multiselect from "../../components/CommonComponents/Select/MultipleSelect";
import SelectFeild from "../../components/CommonComponents/Select";
import RichTextEditor from "../../components/CommonComponents/RichTextEditor";
import MediaSection from "../../pages/InventorySetupNew/MediaSection";
import ProductVariantsModal from "../../pages/InventorySetupNew/ProductVariantsModal";
import VariantSection from "../../pages/InventorySetupNew/VariantSection";
import {
  fetchCategories,
  fetchCreateProduct,
  fetchEditProducts,
  fetchOptionTypes,
  actions,
} from "../../store/reducers/createProfile";
import {
  fetchUpdateProductOptions,
  fetchOptionTypeDetail,
  fetchDeleteVariant,
  fetchGetProductById,
} from "../../store/reducers/createProfile/apithunk";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import rollbar from "../../rollbarConfig";

const statusOptions = ["Active", "InActive"];

const InventoryForm = ({
  control,
  errors,
  updateForm = false,
  onClose,
  watch,
  setValue,
  trigger,
  clearErrors,
  setError,
  editForm = false,
  EditData,
  onEditSubmit,
  SelectedProductId,
  OnEditAndDelete,
  handleShowEditProduct
}) => {
  const theme = useTheme();
  const styles = inventoryFormStyles(theme);
  const dispatch = useDispatch();
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productMedia, setProductMedia] = useState([]);
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [validatedFormData, setValidatedFormData] = useState(null);
  const [optionTypes, setOptionTypes] = useState([]);
  const [availableVariantTypes, setAvailableVariantTypes] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [completedVariants, setCompletedVariants] = useState([]);
  const [variantOptionsMap, setVariantOptionsMap] = useState({});
  const [variantCombinations, setVariantCombinations] = useState([]);
  const [openVariantImageModal, setOpenVariantImageModal] = useState(false);
  const [currentVariantIndex, setCurrentVariantIndex] = useState(null);
  const [variantSelectedImages, setVariantSelectedImages] = useState({});
  const [originalVariantQuantities, setOriginalVariantQuantities] = useState({});
  const [originalVariantData, setOriginalVariantData] = useState({});
  const [modifiedVariants, setModifiedVariants] = useState(new Set());
  const [originalProductData, setOriginalProductData] = useState(null);
  const [editingVariantIds, setEditingVariantIds] = useState(new Set());
  const [editingVariantOriginalData, setEditingVariantOriginalData] = useState({});
  const productVariantsDataRef = React.useRef(null);

  const tagsList = useSelector((state) => state?.createProfile?.tagsList?.data);
  const productVariants = useSelector((state) => state?.createProfile?.productVariants || {});

  const selectedStatus = (status) => {
    if (status === "A") {
      return "Active";
    } else if (status === "In") {
      return "InActive";
    }
  };

  const selectedCategories = (productCategories) => {
    return categories
      ?.map((category) =>
        productCategories?.includes(category?.id) ? category : null
      )
      ?.filter(Boolean);
  };

  const selectedTags = (productTags) => {
    return tags
      ?.map((category) => (productTags?.includes(category?.id) ? category : null))
      ?.filter(Boolean);
  };

  useEffect(() => {
    if (editForm) {
      try {
        setValue("productName", EditData?.name || "");
        setValue("description", EditData?.description || "");
        setValue("priceinUSD", EditData?.price || "");
        setValue("totalQuantity", EditData?.quantity !== undefined ? EditData?.quantity : "");

        const status = selectedStatus(EditData?.status);
        if (status) {
          setValue("status", status);
        }

        const selectedCats = selectedCategories(EditData?.categories);
        if (selectedCats?.length) {
          setValue("Categories", selectedCats);
        }

        const selectedTagsList = selectedTags(EditData?.tags);
        if (selectedTagsList?.length) {
          setValue("tags", selectedTagsList);
        }

        if (EditData?.images && Array.isArray(EditData?.images)) {
          setProductMedia(EditData?.images);
          setValue("productMedia", EditData?.images);
        }
      } catch (error) {
        rollbar.error("Error message", error);
        console.error("Error setting form values:", error);
      }
    }
  }, [editForm, EditData, categories, tags, setValue]);

  useEffect(() => {
    setTags(tagsList);
  }, [tagsList]);

  useEffect(() => {
    if (editForm) {
      const fetchOptionTypesData = async () => {
        try {
          const res = await dispatch(fetchOptionTypes());
          const { data, status, message } = res?.payload || {};
          if (status) {
            setOptionTypes(data);
            setAvailableVariantTypes(data);
          } else {
            ToastNotifyError(message);
          }
        } catch (error) {
          rollbar.error("Error fetching option types", error);
        }
      };
      fetchOptionTypesData();
    }
  }, [editForm, dispatch]);

  useEffect(() => {
    if (editForm && EditData?.id) {
      if (EditData && !originalProductData) {
        setOriginalProductData({
          name: EditData?.name || "",
          description: EditData?.description || "",
          price: EditData?.price || "",
          status: EditData?.status || "A",
          categories: EditData?.categories || [],
          tags: EditData?.tags || [],
          images: EditData?.images || [],
          quantity: EditData?.quantity || "",
          option_types: EditData?.option_types || [],
          option_values_dict: EditData?.option_values_dict || {}
        });
      }

      if (optionTypes?.length > 0) {
        const buildVariantsFromData = async () => {
          try {
            if (EditData?.option_types && EditData?.option_values_dict) {
              productVariantsDataRef.current = {
                variants: EditData?.variants || [],
                option_types: EditData?.option_types || [],
                option_values_dict: EditData?.option_values_dict || {}
              };

              const completedVariantsList = [];
              const productOptionTypes = EditData?.option_types || [];
              const productOptionValuesDict = EditData?.option_values_dict || {};

              for (const optionTypeId of productOptionTypes) {
                try {
                  const optionType = optionTypes?.find(ot => ot?.id === optionTypeId);
                  if (!optionType) continue;

                  const valueIdsArray = productOptionValuesDict[String(optionTypeId)] || productOptionValuesDict[optionTypeId] || [];
                  if (!Array.isArray(valueIdsArray) || valueIdsArray?.length === 0) continue;

                  const uniqueValueIds = new Set(valueIdsArray);
                  const optionValuesRes = await dispatch(fetchOptionTypeDetail(optionTypeId));
                  const { data: optionValuesData, status: optionValuesStatus } = optionValuesRes?.payload || {};

                  if (optionValuesStatus && optionValuesData && Array.isArray(optionValuesData)) {
                    const selectedOptionValues = optionValuesData
                      ?.filter(opt => uniqueValueIds.has(opt.id))
                      ?.map(opt => ({
                        ...opt,
                        name: opt.name || opt.value || opt.display_name || `Option ${opt.id}`
                      }));

                    if (selectedOptionValues?.length > 0) {
                      completedVariantsList.push({
                        id: `completed_${optionTypeId}_${Date.now()}`,
                        type: optionType,
                        selectedOptions: selectedOptionValues
                      });
                    }
                  }
                } catch (error) {
                  console.error(`Error fetching option values for type ${optionTypeId}:`, error);
                }
              }

              setCompletedVariants(completedVariantsList);
              const usedTypeIds = completedVariantsList?.map(cv => cv.type?.id);
              setAvailableVariantTypes(prev => prev?.filter(type => !usedTypeIds.includes(type.id)));

              if (EditData?.variants && Array.isArray(EditData?.variants) && EditData?.variants?.length > 0) {
                const mappedVariants = EditData?.variants?.map((variant) => ({
                  id: variant.id,
                  options: variant?.options,
                  option_values_with_hex: variant?.option_values_with_hex,
                  price: variant?.price || '',
                  quantity: variant?.quantity || 0,
                  media: variant?.variant_img || [],
                  variant_title: variant?.variant_title,
                  displayName: variant?.display_name || variant?.variant_title || `Variant ${variant?.id}`,
                  display_name: variant?.display_name,
                  variantData: variant
                }));

                setVariantCombinations(mappedVariants);

                const originalQuantities = {};
                const originalData = {};
                mappedVariants?.forEach((variant, index) => {
                  setValue(`variantCombinations.${index}.id`, variant?.id);
                  setValue(`variantCombinations.${index}.price`, variant?.price);
                  setValue(`variantCombinations.${index}.quantity`, variant?.quantity);
                  setValue(`variantCombinations.${index}.media`, variant?.media);

                  if (variant?.id) {
                    originalQuantities[variant?.id] = variant?.quantity || 0;
                    originalData[variant?.id] = {
                      price: variant?.price || '',
                      quantity: variant?.quantity || 0,
                      media: variant?.media || []
                    };
                  }
                });
                setOriginalVariantQuantities(originalQuantities);
                setOriginalVariantData(originalData);
              }
            }
          } catch (error) {
            rollbar.error("Error building variants", error);
          }
        };

        buildVariantsFromData();
      }
    }
  }, [editForm, EditData, optionTypes, dispatch, setValue, originalProductData]);

  const saveProduct = async (formDataToSave = null) => {
    const dataToUse = formDataToSave || validatedFormData;
    if (!dataToUse) return null;

    try {
      const allVariantData = watch('variantCombinations') || [];
      const hasVariants = variantCombinations?.length > 0 || allVariantData?.length > 0;
      const payload = {};

      if (editForm && originalProductData) {
        const currentName = dataToUse?.productName;
        const currentDescription = dataToUse?.description || "";
        const currentPrice = String(dataToUse?.priceinUSD || dataToUse?.price || "");
        const currentStatus = dataToUse?.status === "Active" ? "A" : "In";
        const currentCategories = dataToUse?.Categories?.map(cat => cat?.id) || [];
        const currentTags = dataToUse?.tags?.map(tag => tag?.id) || [];
        const currentImages = dataToUse?.productMedia || productMedia || [];

        if (currentName !== (originalProductData.name || "")) {
          payload.name = currentName;
        }

        if (currentDescription !== (originalProductData.description || "")) {
          payload.description = currentDescription;
        }

        const currentPriceNum = dataToUse?.priceinUSD || dataToUse?.price;
        const currentPriceNumValue = currentPriceNum && currentPriceNum !== ""
          ? Number(currentPriceNum)
          : null;
        const originalPriceNum = originalProductData.price && originalProductData.price !== ""
          ? Number(originalProductData.price)
          : null;

        const currentIsValid = currentPriceNumValue !== null && !isNaN(currentPriceNumValue);
        const originalIsValid = originalPriceNum !== null && !isNaN(originalPriceNum);

        if (!currentIsValid && !originalIsValid) {
        } else if (currentIsValid !== originalIsValid || currentPriceNumValue !== originalPriceNum) {
          payload.price = currentPrice;
        }

        if (currentStatus !== (originalProductData.status === "Active" ? "A" : "In")) {
          payload.status = currentStatus;
        }

        const originalCategories = originalProductData.categories || [];
        const categoriesChanged = JSON.stringify(currentCategories.sort()) !== JSON.stringify(originalCategories.sort());
        if (categoriesChanged) {
          payload.categories = currentCategories;
        }

        const originalTags = originalProductData.tags || [];
        const tagsChanged = JSON.stringify(currentTags.sort()) !== JSON.stringify(originalTags.sort());
        if (tagsChanged) {
          payload.tags = currentTags;
        }

        const originalImages = originalProductData.images || [];
        const imagesChanged = JSON.stringify(currentImages.sort()) !== JSON.stringify(originalImages.sort());
        if (imagesChanged) {
          payload.images = currentImages;
        }

        if (!hasVariants) {
          const currentQuantity = dataToUse?.totalQuantity || dataToUse?.quantity;
          const originalQuantity = originalProductData.quantity || "";
          if (String(currentQuantity) !== String(originalQuantity)) {
            payload.quantity = Number(currentQuantity || 0);
          }
        }

        if (completedVariants?.length > 0) {
          const optionTypesArray = completedVariants?.map(cv => cv.type?.id)?.filter(Boolean);
          const optionValuesDict = {};
          completedVariants?.forEach(cv => {
            if (cv.type?.id && cv.selectedOptions && Array.isArray(cv.selectedOptions)) {
              const valueIds = cv.selectedOptions?.map(opt => opt.id)?.filter(Boolean);
              if (valueIds?.length > 0) {
                optionValuesDict[String(cv.type?.id)] = valueIds;
              }
            }
          });

          if (originalProductData?.option_types && originalProductData?.option_values_dict) {
            const originalOptionTypes = originalProductData.option_types || [];
            const originalOptionValuesDict = originalProductData.option_values_dict || {};

            const optionTypesChanged = JSON.stringify(optionTypesArray.sort()) !== JSON.stringify(originalOptionTypes.sort());
            if (optionTypesChanged) {
              payload.option_types = optionTypesArray;
            }

            const optionValuesDictChanged = JSON.stringify(optionValuesDict) !== JSON.stringify(originalOptionValuesDict);
            if (optionValuesDictChanged) {
              payload.option_values_dict = optionValuesDict;
            }
          } else {
            payload.option_types = optionTypesArray;
            payload.option_values_dict = optionValuesDict;
          }

          const variantDataArray = [];
          allVariantData.forEach((variantData, index) => {
            const variantId = variantData?.id;

            if (variantId && modifiedVariants.has(variantId)) {
              const quantity = Number(variantData?.quantity) || 0;
              const price = variantData?.price ? String(variantData.price) : null;
              const media = variantData?.media;
              const variantImages = media && Array.isArray(media) ? media : (media ? [media] : []);

              const variantPayload = {
                id: variantId,
                quantity: quantity,
              };

              if (price) {
                variantPayload.price = price;
              }

              if (variantImages && variantImages.length > 0) {
                variantPayload.variant_img = variantImages;
              }

              variantDataArray.push(variantPayload);
            }
          });

          if (variantDataArray.length > 0) {
            payload.variant_data = variantDataArray;
          }
        }
      } else {
        payload.name = dataToUse?.productName;
        payload.description = dataToUse?.description || "";
        payload.price = String(dataToUse?.priceinUSD || dataToUse?.price || "");
        payload.status = dataToUse?.status === "Active" ? "A" : "In";
        payload.categories = dataToUse?.Categories?.map(cat => cat?.id) || [];
        payload.tags = dataToUse?.tags?.map(tag => tag?.id) || [];
        payload.images = dataToUse?.productMedia || productMedia || [];

        if (!hasVariants) {
          payload.quantity = Number(dataToUse?.totalQuantity || dataToUse?.quantity || 0);
        }
      }

      let productId = EditData?.id;

      if (editForm && productId) {
        const response = await dispatch(fetchEditProducts({
          id: productId,
          dataToSend: payload
        }));

        const { status, data, message } = response?.payload || {};
        if (status) {
          productId = data?.id || productId;
          ToastNotifySuccess("Product updated successfully!");
          setModifiedVariants(new Set());
          if (editForm) {
            await refreshVariantsList();
          }

          return productId;
        } else {
          ToastNotifyError(message || "Failed to update product");
          return null;
        }
      } else {
        const response = await dispatch(fetchCreateProduct(payload));

        const { status, data, message } = response?.payload || {};
        if (status) {
          productId = data?.id || data?.data?.id;
          ToastNotifySuccess("Product added successfully!");
          return productId;
        } else {
          ToastNotifyError(message || "Failed to create product");
          return null;
        }
      }
    } catch (error) {
      rollbar.error("Error saving product", error);
      ToastNotifyError("Failed to save product");
      return null;
    }
  };

  const handleSaveAsSingleProduct = async () => {
    const formData = watch();
    const currentMedia = formData?.productMedia || productMedia;
    const validatedData = {
      ...formData,
      productMedia: currentMedia
    };
    setValidatedFormData(validatedData);

    const productId = await saveProduct(validatedData);

    if (productId) {
      setOpenVariantModal(false);

      if (onClose) {
        onClose();
      }

      if (OnEditAndDelete) {
        OnEditAndDelete();
      }
    } else {
      setOpenVariantModal(false);
    }
  };

  const handleAddVariants = async () => {
    const formData = watch();
    const currentMedia = formData?.productMedia || productMedia;
    const validatedData = {
      ...formData,
      productMedia: currentMedia
    };
    setValidatedFormData(validatedData);

    const productId = await saveProduct(validatedData);

    if (productId) {
      setOpenVariantModal(false);

      if (onClose) {
        onClose();
      }

      if (OnEditAndDelete) {
        await OnEditAndDelete();
      }

      setTimeout(() => {
        if (handleShowEditProduct) {
          handleShowEditProduct(productId);
        } else if (onEditSubmit && SelectedProductId) {
          SelectedProductId(productId);
          onEditSubmit(productId);
        }
      }, 500);
    } else {
      setOpenVariantModal(false);
    }
  };

  const handleSaveButtonClick = async (e) => {
    e.preventDefault();

    if (clearErrors) {
      clearErrors("totalQuantity");
    }

    const formData = watch();

    const isValid = await trigger();

    if (!isValid) {
      ToastNotifyError("Please fill in all required fields");
      return;
    }

    const currentMedia = formData?.productMedia || productMedia;
    if (!currentMedia || currentMedia?.length === 0) {
      ToastNotifyError("Media file is mandatory.");
      return;
    }

    // Store validated form data
    setValidatedFormData({
      ...formData,
      productMedia: currentMedia
    });

    // Open modal
    setOpenVariantModal(true);
  };

  // Handle Save & Continue button click - save product and close edit form
  const handleSaveAndContinue = async (e) => {
    e.preventDefault();

    // Clear any manually set errors on totalQuantity (especially sum validation errors)
    if (clearErrors) {
      clearErrors("totalQuantity");
    }

    // Get all form values
    const formData = watch();

    // Validate all fields
    const isValid = await trigger();

    if (!isValid) {
      ToastNotifyError("Please fill in all required fields");
      return;
    }

    // Check if productMedia is set
    const currentMedia = formData?.productMedia || productMedia;
    if (!currentMedia || currentMedia?.length === 0) {
      ToastNotifyError("Media file is mandatory.");
      return;
    }

    // Validate all variants: if quantity > 0, image is required
    if (editForm) {
      const allVariantData = watch('variantCombinations') || [];
      const validationErrors = [];

      for (let index = 0; index < allVariantData?.length; index++) {
        const variantData = allVariantData[index];
        const quantity = Number(variantData?.quantity) || 0;
        const media = variantData?.media;
        const variantImages = media && Array.isArray(media) ? media : (media ? [media] : []);

        // If quantity > 0, image is required for this variant
        if (quantity > 0 && (!variantImages || variantImages?.length === 0)) {
          validationErrors.push({
            index,
            variantIndex: index,
            message: `Image is a mandatory field.`
          });
          if (setError) {
            setError(`variantCombinations.${index}.media`, {
              type: 'manual',
              message: 'Image is a mandatory field.'
            });
          }
        }
      }

      if (validationErrors?.length > 0) {
        if (validationErrors?.length === 1) {
          ToastNotifyError(`Image is a mandatory field for variant`);
        } else {
          ToastNotifyError(`Image is a mandatory field for variants.`);
        }
        return;
      }
    }

    // Store validated form data
    const validatedData = {
      ...formData,
      productMedia: currentMedia
    };
    setValidatedFormData(validatedData);

    // Save the product (pass validatedData directly to avoid async state issues)
    const productId = await saveProduct(validatedData);

    if (productId) {
      if (onClose) {
        onClose();
      }

      if (OnEditAndDelete) {
        OnEditAndDelete();
      }
    }
  };

  const handleRemoveVariant = (variantId) => {
    const variantToRemove = selectedVariants?.find((v) => v?.id === variantId);
    if (variantToRemove && variantToRemove?.type) {
      if (!availableVariantTypes?.find((t) => t?.id === variantToRemove?.type?.id)) {
        setAvailableVariantTypes((prev) => [...prev, variantToRemove?.type]);
      }
      setVariantOptionsMap((prev) => {
        const newMap = { ...prev };
        delete newMap[variantToRemove?.type?.id];
        return newMap;
      });
    }
    setSelectedVariants((prev) => prev?.filter((v) => v?.id !== variantId));
  };

  const handleVariantDone = async (variantId, variantType, selectedOptions) => {
    const variantData = {
      type: variantType,
      selectedOptions: selectedOptions || [],
      variantOptions: variantOptionsMap[variantType?.id] || [],
    };

    const variantBeingDone = selectedVariants?.find((v) => v.id === variantId);
    const originalCompletedVariantId = variantBeingDone?.originalCompletedVariantId;

    const completedVariantId = `completed_${Date.now()}`;
    dispatch(actions.setProductVariant({
      variantId: completedVariantId,
      variantData
    }));

    setSelectedVariants((prev) => prev?.filter((v) => v.id !== variantId));

    const newCompletedVariant = {
      id: completedVariantId,
      type: variantType,
      selectedOptions: selectedOptions || [],
    };

    setCompletedVariants((prev) => [...prev, newCompletedVariant]);

    if (originalCompletedVariantId) {
      setEditingVariantIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(originalCompletedVariantId);
        return newSet;
      });

      setEditingVariantOriginalData((prev) => {
        const newData = { ...prev };
        delete newData[originalCompletedVariantId];
        return newData;
      });
    }
  };

  const handleSaveVariantTypes = async () => {
    if (!editForm || !EditData?.id) {
      ToastNotifyError("Cannot save variants in create mode");
      return;
    }

    if (!completedVariants || completedVariants?.length === 0) {
      ToastNotifyError("Please add at least one variant type");
      return;
    }

    try {
      const optionValuesDict = {};
      completedVariants?.forEach(v => {
        if (v?.type && v?.selectedOptions) {
          const typeId = String(v.type?.id);
          const valueIds = v?.selectedOptions?.map(opt => opt?.id)?.filter(Boolean);
          if (valueIds?.length > 0) {
            optionValuesDict[typeId] = valueIds;
          }
        }
      });

      const optionTypesArray = completedVariants?.map(cv => cv.type?.id)?.filter(Boolean);
      const uniqueOptionTypes = [...new Set(optionTypesArray)];

      const currentFormData = watch();
      const payload = {
        name: currentFormData?.productName || "",
        description: currentFormData?.description || "",
        option_types: uniqueOptionTypes,
        option_values_dict: optionValuesDict
      };
      const response = await dispatch(fetchUpdateProductOptions({
        productId: EditData?.id,
        data: payload
      }));
      const { status, message: responseMessage } = response?.payload || {};
      if (status) {
        ToastNotifySuccess("Variant types saved successfully!");
        await refreshVariantsList();
        updateTotalQuantity();
      } else {
        ToastNotifyError(responseMessage || "Failed to save variant types");
      }
    } catch (error) {
      console.error("Error saving variant types:", error);
      rollbar.error("Error saving variant types", error);
      ToastNotifyError("Failed to save variant types");
    }
  };

  const handleRemoveCompletedVariant = (completedVariantId) => {
    const variantToRemove = completedVariants?.find((v) => v?.id === completedVariantId);
    if (variantToRemove && variantToRemove?.type) {
      if (!availableVariantTypes?.find((t) => t?.id === variantToRemove?.type?.id)) {
        setAvailableVariantTypes((prev) => [...prev, variantToRemove?.type]);
      }
    }
    setCompletedVariants((prev) => prev?.filter((v) => v?.id !== completedVariantId));
    dispatch(actions.clearProductVariant({ variantId: completedVariantId }));
    if (editingVariantIds.has(completedVariantId)) {
      setEditingVariantIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(completedVariantId);
        return newSet;
      });

      setEditingVariantOriginalData((prev) => {
        const newData = { ...prev };
        delete newData[completedVariantId];
        return newData;
      });
    }
  };

  const handleEditCompletedVariant = (completedVariant) => {
    setEditingVariantOriginalData((prev) => ({
      ...prev,
      [completedVariant.id]: {
        id: completedVariant.id,
        type: completedVariant.type,
        selectedOptions: completedVariant.selectedOptions || [],
      },
    }));

    setEditingVariantIds((prev) => {
      const newSet = new Set(prev);
      newSet.add(completedVariant.id);
      return newSet;
    });

    const storedVariantData = productVariants[completedVariant?.id];
    const variantToRemove = completedVariants?.find((v) => v?.id === completedVariant?.id);
    if (variantToRemove && variantToRemove?.type) {
      if (!availableVariantTypes?.find((t) => t?.id === variantToRemove?.type?.id)) {
        setAvailableVariantTypes((prev) => [...prev, variantToRemove?.type]);
      }
    }
    setCompletedVariants((prev) => prev?.filter((v) => v?.id !== completedVariant?.id));
    const newVariant = {
      id: Date.now(),
      originalCompletedVariantId: completedVariant.id,
      type: completedVariant?.type,
      selectedOptions: storedVariantData?.selectedOptions || completedVariant?.selectedOptions || [],
      variantOptions: storedVariantData?.variantOptions || variantOptionsMap[completedVariant?.type?.id] || [],
    };
    setSelectedVariants((prev) => [...prev, newVariant]);
    if (storedVariantData?.variantOptions && storedVariantData?.variantOptions?.length > 0) {
      setVariantOptionsMap((prev) => ({
        ...prev,
        [completedVariant?.type?.id]: storedVariantData?.variantOptions,
      }));
    }
    setTimeout(() => {
      setValue(`variants.${newVariant.id}.variantType`, completedVariant?.type);
      if (newVariant?.selectedOptions && newVariant?.selectedOptions?.length > 0) {
        setValue(`variants.${newVariant.id}.variantOption`, newVariant?.selectedOptions);
      }
    }, 150);
  };

  const handleOpenVariantImageModal = (variantIndex) => {
    setCurrentVariantIndex(variantIndex);
    const formValue = watch(`variantCombinations.${variantIndex}.media`);
    if (formValue && Array.isArray(formValue) && formValue?.length > 0) {
      const selectedIndices = formValue
        ?.map(url => productMedia?.findIndex(mediaUrl => mediaUrl === url))
        ?.filter(idx => idx !== -1);
      setVariantSelectedImages((prev) => ({
        ...prev,
        [variantIndex]: selectedIndices,
      }));
    } else {
      setVariantSelectedImages((prev) => ({
        ...prev,
        [variantIndex]: [],
      }));
    }
    setOpenVariantImageModal(true);
  };

  const handleCloseVariantImageModal = () => {
    if (currentVariantIndex !== null) {
      const combination = variantCombinations?.[currentVariantIndex];
      const variantId = combination?.id;
      if (variantId && originalVariantData[variantId]) {
        const originalData = originalVariantData[variantId];
        const originalMedia = Array.isArray(originalData?.media) ? originalData?.media : (originalData?.media ? [originalData?.media] : []);
        if (originalMedia?.length > 0 && originalMedia[0]) {
          const originalImageIndex = productMedia?.findIndex(url => url === originalMedia[0]);
          if (originalImageIndex !== -1) {
            setVariantSelectedImages((prev) => ({
              ...prev,
              [currentVariantIndex]: [originalImageIndex]
            }));
          } else {
            setVariantSelectedImages((prev) => {
              const newState = { ...prev };
              delete newState[currentVariantIndex];
              return newState;
            });
          }
        } else {
          setVariantSelectedImages((prev) => {
            const newState = { ...prev };
            delete newState[currentVariantIndex];
            return newState;
          });
        }
      } else {
        setVariantSelectedImages((prev) => {
          const newState = { ...prev };
          delete newState[currentVariantIndex];
          return newState;
        });
      }
    }
    setOpenVariantImageModal(false);
    setCurrentVariantIndex(null);
  };

  const handleToggleVariantImageSelection = (imageIndex) => {
    if (currentVariantIndex === null) return;
    setVariantSelectedImages((prev) => ({
      ...prev,
      [currentVariantIndex]: [imageIndex]
    }));
  };

  const handleSaveVariantImages = () => {
    if (currentVariantIndex === null) return;
    const selectedIndices = variantSelectedImages?.[currentVariantIndex] || [];
    const selectedImageUrl = selectedIndices?.length > 0 ? productMedia?.[selectedIndices[0]] : null;
    setValue(`variantCombinations.${currentVariantIndex}.media`, selectedImageUrl ? [selectedImageUrl] : []);
    handleVariantChange(currentVariantIndex, 'media', selectedImageUrl ? [selectedImageUrl] : []);
    if (selectedImageUrl) {
      // Clear errors when image is selected
      if (clearErrors) {
        clearErrors(`variantCombinations.${currentVariantIndex}.media`);
      }
    }
    handleCloseVariantImageModal();
  };

  const handleDeleteVariantCombination = async (variantIndex) => {
    try {
      const combination = variantCombinations?.[variantIndex];
      const allVariantData = watch('variantCombinations') || [];
      const formData = allVariantData[variantIndex] || {};
      const variantId = formData.id || combination?.id;
      if (variantId && editForm) {
        const response = await dispatch(fetchDeleteVariant(variantId));
        const { status, message } = response?.payload || {};
        if (!status) {
          ToastNotifyError(message || "Failed to delete variant");
          return;
        }
        ToastNotifySuccess("Variant deleted successfully!");
      }
      const updatedCombinations = variantCombinations.filter((_, idx) => idx !== variantIndex);
      setVariantCombinations(updatedCombinations);
      const updatedFormData = allVariantData.filter((_, idx) => idx !== variantIndex);
      updatedFormData.forEach((variant, idx) => {
        setValue(`variantCombinations.${idx}.id`, variant.id);
        setValue(`variantCombinations.${idx}.price`, variant.price);
        setValue(`variantCombinations.${idx}.quantity`, variant.quantity);
        setValue(`variantCombinations.${idx}.media`, variant.media);
      });
      if (allVariantData?.length > updatedFormData?.length) {
        const lastIndex = allVariantData?.length - 1;
        setValue(`variantCombinations.${lastIndex}.id`, undefined);
        setValue(`variantCombinations.${lastIndex}.price`, undefined);
        setValue(`variantCombinations.${lastIndex}.quantity`, undefined);
        setValue(`variantCombinations.${lastIndex}.media`, undefined);
      }
      setVariantSelectedImages((prev) => {
        const newState = { ...prev };
        delete newState[variantIndex];
        const reindexed = {};
        Object.keys(newState).forEach((key) => {
          const oldIndex = parseInt(key);
          if (oldIndex > variantIndex) {
            reindexed[oldIndex - 1] = newState[key];
          } else if (oldIndex < variantIndex) {
            reindexed[oldIndex] = newState[key];
          }
        });
        return reindexed;
      });
      if (variantId && originalVariantQuantities[variantId]) {
        setOriginalVariantQuantities((prev) => {
          const newState = { ...prev };
          delete newState[variantId];
          return newState;
        });
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
      rollbar.error("Error deleting variant", error);
      ToastNotifyError("Failed to delete variant");
    }
  };

  // Note: Variants are now saved via product PATCH API in saveProduct function
  // This function is kept for compatibility but doesn't make API calls
  // Variants will be saved when clicking "Save & Continue"
  const handleSaveVariant = async (variantIndex) => {
    // Just update total quantity when variant is modified
    // The actual save happens via product PATCH API in saveProduct
    updateTotalQuantity();
    ToastNotifySuccess("Variant changes will be saved when you click 'Save & Continue'");
  };

  const handleDiscardVariant = (variantIndex) => {
    try {
      const combination = variantCombinations?.[variantIndex];
      const variantId = combination?.id;
      if (!variantId || !originalVariantData?.[variantId]) {
        ToastNotifyError("Cannot discard changes - original data not found");
        return;
      }
      const originalData = originalVariantData[variantId];
      setValue(`variantCombinations.${variantIndex}.price`, originalData?.price);
      setValue(`variantCombinations.${variantIndex}.quantity`, originalData?.quantity);
      setValue(`variantCombinations.${variantIndex}.media`, originalData?.media);
      const originalMedia = Array.isArray(originalData?.media) ? originalData?.media : (originalData?.media ? [originalData?.media] : []);
      if (originalMedia?.length > 0 && originalMedia[0]) {
        const originalImageIndex = productMedia?.findIndex(url => url === originalMedia[0]);
        if (originalImageIndex !== -1) {
          setVariantSelectedImages((prev) => ({
            ...prev,
            [variantIndex]: [originalImageIndex]
          }));
        } else {
          setVariantSelectedImages((prev) => {
            const newState = { ...prev };
            delete newState[variantIndex];
            return newState;
          });
        }
      } else {
        setVariantSelectedImages((prev) => {
          const newState = { ...prev };
          delete newState[variantIndex];
          return newState;
        });
      }
      setModifiedVariants(prev => {
        const newSet = new Set(prev);
        newSet.delete(variantId);
        return newSet;
      });
      ToastNotifySuccess("Changes discarded");
    } catch (error) {
      console.error("Error discarding variant:", error);
      rollbar.error("Error discarding variant", error);
      ToastNotifyError("Failed to discard changes");
    }
  };

  // Calculate total quantity from all variants
  const calculateTotalQuantityFromVariants = () => {
    const allVariantData = watch('variantCombinations') || [];
    const totalQuantity = allVariantData.reduce((sum, variant) => {
      const quantity = Number(variant?.quantity) || 0;
      return sum + quantity;
    }, 0);
    return totalQuantity;
  };

  // Update total quantity field based on variant quantities
  const updateTotalQuantity = () => {
    const allVariantData = watch('variantCombinations') || [];
    const hasVariants = variantCombinations?.length > 0 || allVariantData?.length > 0;

    if (hasVariants) {
      const totalQuantity = calculateTotalQuantityFromVariants();
      setValue('totalQuantity', String(totalQuantity));
    }
  };

  // Effect to update total quantity when variants change
  // Watch variantCombinations form values to detect quantity changes
  const watchedVariantCombinations = watch('variantCombinations');
  useEffect(() => {
    const allVariantData = watchedVariantCombinations || [];
    const hasVariants = variantCombinations?.length > 0 || allVariantData?.length > 0;

    if (hasVariants) {
      updateTotalQuantity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchedVariantCombinations, variantCombinations?.length]);

  // Helper function to refresh variants list from API
  const refreshVariantsList = async () => {
    if (!editForm || !EditData?.id) return;

    try {
      const res = await dispatch(fetchGetProductById(EditData.id));
      if (res?.payload?.status === 404) {
        return;
      }
      const { data, status } = res?.payload || {};

      if (status && data && data.variants && Array.isArray(data.variants) && data.variants?.length > 0) {
        // Map API variants to variantCombinations format
        const mappedVariants = data.variants?.map((variant) => {
          return {
            id: variant.id,
            options: variant.options,
            option_values_with_hex: variant.option_values_with_hex,
            price: variant.price || '',
            quantity: variant.quantity || 0,
            media: variant.variant_img || [],
            variant_title: variant.variant_title,
            displayName: variant.display_name || variant.variant_title || `Variant ${variant.id}`,
            display_name: variant.display_name,
            variantData: variant
          };
        });

        // Set variant combinations from API
        setVariantCombinations(mappedVariants);

        // Set form values for each variant combination
        const originalQuantities = {};
        const originalData = {};
        mappedVariants.forEach((variant, index) => {
          setValue(`variantCombinations.${index}.id`, variant.id);
          setValue(`variantCombinations.${index}.price`, variant.price);
          setValue(`variantCombinations.${index}.quantity`, variant.quantity);
          setValue(`variantCombinations.${index}.media`, variant.media);

          // Store original quantity for validation
          if (variant.id) {
            originalQuantities[variant.id] = variant.quantity || 0;
            originalData[variant.id] = {
              price: variant.price || '',
              quantity: variant.quantity || 0,
              media: variant.media || []
            };
          }
        });
        setOriginalVariantQuantities(originalQuantities);
        setOriginalVariantData(originalData);

        // Update total quantity after refreshing variants
        updateTotalQuantity();
      }
    } catch (error) {
      console.error("Error refreshing variants:", error);
      rollbar.error("Error refreshing variants", error);
    }
  };

  const handleDiscardCompletedVariant = (variantIdToDiscard) => {
    if (!variantIdToDiscard || !editingVariantOriginalData[variantIdToDiscard]) return;

    const editingVariant = selectedVariants?.find((v) => v?.originalCompletedVariantId === variantIdToDiscard);
    if (!editingVariant) return;

    const originalData = editingVariantOriginalData[variantIdToDiscard];

    const restoredCompletedVariant = {
      id: originalData?.id,
      type: originalData?.type,
      selectedOptions: originalData?.selectedOptions || [],
    };

    setCompletedVariants((prev) => [...prev, restoredCompletedVariant]);

    if (editingVariant.type) {
      setAvailableVariantTypes((prev) => prev.filter((t) => t.id !== editingVariant.type?.id));
    }

    setSelectedVariants((prev) => prev.filter((v) => v.originalCompletedVariantId !== variantIdToDiscard));

    setEditingVariantIds((prev) => {
      const newSet = new Set(prev);
      newSet.delete(variantIdToDiscard);
      return newSet;
    });

    setEditingVariantOriginalData((prev) => {
      const newData = { ...prev };
      delete newData[variantIdToDiscard];
      return newData;
    });
  };

  const handleVariantChange = (variantIndex, field, value) => {
    const combination = variantCombinations?.[variantIndex];
    const variantId = combination?.id;
    if (!variantId || !originalVariantData[variantId]) return;
    const originalData = originalVariantData[variantId];
    let isModified = false;
    if (field === 'price') {
      isModified = String(originalData.price || '') !== String(value || '');
    } else if (field === 'quantity') {
      isModified = Number(originalData.quantity || 0) !== Number(value || 0);
    } else if (field === 'media') {
      const originalMedia = Array.isArray(originalData.media) ? originalData.media : (originalData.media ? [originalData.media] : []);
      const newMedia = Array.isArray(value) ? value : (value ? [value] : []);
      isModified = JSON.stringify(originalMedia.sort()) !== JSON.stringify(newMedia.sort());
    }
    setModifiedVariants(prev => {
      const newSet = new Set(prev);
      if (isModified) {
        newSet.add(variantId);
      } else {
        newSet.delete(variantId);
      }
      return newSet;
    });
  };

  useEffect(() => {
    const getCatergories = async () => {
      try {
        const res = await dispatch(fetchCategories());
        const { data, status, message } = res?.payload;
        if (status) {
          setCategories(data);
        } else {
          ToastNotifyError(message);
        }
      } catch (error) {
        rollbar.error("Error message", error);
        console.error("Login failed:", error);
      }
    };

    getCatergories();
  }, []);

  return (
    <Box>
      <Box sx={updateForm ? styles.updateFormWrap : styles.formWrap}>
        <Box sx={updateForm ? styles.updateHeaderWrap : styles.headerWrap}>
          {editForm ? (
            <Typography sx={styles.header}>Edit Product</Typography>
          ) : (
            <Typography sx={styles.header}>Add new product</Typography>
          )}
          {updateForm && (
            <Box sx={styles.productCloseWrap} onClick={onClose}>
              <Typography sx={styles.productCloseText}>Close</Typography>
              <CloseRoundedIcon sx={styles.productCloseIcon} />
            </Box>
          )}
        </Box>
        <Box sx={styles.inventoryFormWrap}>
          <Box>
            <Box>
              <Typography sx={styles.subHeading}>
                Product Information
              </Typography>
            </Box>
            <Box sx={styles.productInformationTextfields}>
              <Box sx={styles.doubleTextfields}>
                <Box sx={styles.textFields}>
                  <Controller
                    name='productName'
                    control={control}
                    defaultValue=''
                    render={({ field }) => (
                      <TextFeild
                        {...field}
                        id='productName'
                        required
                        label={INPUT_LABELS.productName}
                        placeholder='Product name'
                        variant='outlined'
                        fullWidth
                        margin='normal'
                        error={!!errors.productName}
                        helperText={errors.productName?.message}
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box sx={styles.doubleTextfields}>
                <Box sx={styles.textFields}>
                  <Controller
                    name='Categories'
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                      <Multiselect
                        name='Categories'
                        id='Categories'
                        required
                        label={INPUT_LABELS.Categories}
                        placeholder='Categories'
                        error={!!errors.Categories}
                        helperText={errors.Categories?.message}
                        options={categories}
                        objectOptions={true}
                        onChange={(selectedOptions) =>
                          field.onChange(selectedOptions)
                        }
                        {...field}
                      />
                    )}
                  />
                </Box>
                <Box sx={styles.textFields}>
                  <Controller
                    name='status'
                    control={control}
                    defaultValue=''
                    render={({ field }) => (
                      <SelectFeild
                        {...field}
                        id='status'
                        required
                        label={INPUT_LABELS.status}
                        placeholder='Select Status'
                        options={statusOptions}
                        error={!!errors.status}
                        helperText={errors.status?.message}
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box sx={styles.doubleTextfields}>
                <Box sx={styles.textFields}>
                  <Controller
                    name='tags'
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                      <Multiselect
                        name='tags'
                        id='tags'
                        required
                        label={INPUT_LABELS.tags}
                        placeholder='Select Tags'
                        error={!!errors.tags}
                        helperText={errors.tags?.message}
                        options={tags}
                        objectOptions={true}
                        onChange={(selectedOptions) =>
                          field.onChange(selectedOptions)
                        }
                        {...field}
                      />
                    )}
                  />
                </Box>
              </Box>
              <Box>
                <Controller
                  name='description'
                  control={control}
                  defaultValue=''
                  render={({ field }) => (
                    <RichTextEditor
                      {...field}
                      id='description'
                      label={INPUT_LABELS.description}
                      placeholder='Enter description here'
                      fullWidth
                      margin='normal'
                      maxHeight='200px'
                      error={!!errors.description}
                      helperText={errors.description?.message}
                    />
                  )}
                />
              </Box>
            </Box>
          </Box>

          {/* Media Section - Product level, just below Description */}
          <Box>
            <Controller
              name="productMedia"
              control={control}
              defaultValue={[]}
              render={({ field }) => {
                // Sync field value with productMedia state
                const currentMedia = field.value && field.value?.length > 0 ? field.value : productMedia;

                return (
                  <>
                    <MediaSection
                      productMedia={currentMedia}
                      setProductMedia={(newMedia) => {
                        setProductMedia(newMedia);
                        field.onChange(newMedia);
                        // Trigger validation
                        setValue('productMedia', newMedia, { shouldValidate: true });
                      }}
                      setValue={setValue}
                      handleRemoveMedia={(mediaIndex) => {
                        const updatedMedia = currentMedia?.filter((_, idx) => idx !== mediaIndex);
                        setProductMedia(updatedMedia);
                        field.onChange(updatedMedia);
                        // Trigger validation
                        setValue('productMedia', updatedMedia, { shouldValidate: true });
                      }}
                    />
                    {errors.productMedia && (
                      <Typography
                        sx={{
                          color: theme.palette?.error?.main || "#d32f2f",
                          fontSize: "12px",
                          marginTop: "4px",
                          marginLeft: "14px",
                        }}
                      >
                        {errors.productMedia?.message}
                      </Typography>
                    )}
                  </>
                );
              }}
            />
          </Box>
          {(() => {
            // Check if any variant has shopify_variant_id
            const hasShopifyVariant = variantCombinations?.some(variant => variant?.variantData?.shopify_variant_id);
            
            // Hide the entire section if any variant has shopify_variant_id
            if (hasShopifyVariant) {
              return null;
            }
            
            return (
              <Box>
                <Box>
                  <Typography sx={styles.subHeading}>
                    Pricing & Quantity
                  </Typography>
                </Box>
                <Box sx={styles.productInformationTextfields}>
                  <Box sx={styles.doubleTextfields}>
                    <Box sx={styles.textFields}>
                      <Controller
                        name='priceinUSD'
                        control={control}
                        defaultValue=''
                        render={({ field }) => (
                          <TextFeild
                            {...field}
                            id='priceinUSD'
                            required
                            label={INPUT_LABELS.priceinUSD}
                            placeholder='Enter Price (in USD)'
                            variant='outlined'
                            fullWidth
                            margin='normal'
                            error={!!errors.priceinUSD}
                            helperText={errors.priceinUSD?.message}
                            type='number'
                          />
                        )}
                      />
                    </Box>
                    <Box sx={styles.textFields}>
                      <Controller
                        name='totalQuantity'
                        control={control}
                        defaultValue='1'
                        render={({ field }) => {
                          const allVariantData = watch('variantCombinations') || [];
                          const hasVariants = variantCombinations?.length > 0 || allVariantData?.length > 0;

                          const totalQuantity = calculateTotalQuantityFromVariants();

                          const isDisabled = hasVariants;

                          const displayValue = hasVariants ? String(totalQuantity) : field.value;

                          return (
                            <TextFeild
                              {...field}
                              id='totalQuantity'
                              required={!hasVariants}
                              disabled={isDisabled}
                              type='number'
                              label={INPUT_LABELS.totalQuantity}
                              placeholder='Enter total quantity'
                              variant='outlined'
                              fullWidth
                              margin='normal'
                              error={!!errors.totalQuantity}
                              helperText={errors.totalQuantity?.message || (isDisabled ? 'Total quantity is calculated from variants' : '')}
                              inputProps={{
                                min: 0,
                                step: 1,
                              }}
                              value={displayValue}
                              onChange={(e) => {
                                if (!hasVariants) {
                                  const newValue = e.target.value;
                                  const currentValue = field.value?.toString() || '';

                                  if (currentValue === '0' && newValue?.length > 1 && newValue?.startsWith('0')) {
                                    const replacedValue = newValue?.replace(/^0+/, '') || '0';
                                    field.onChange({ ...e, target: { ...e.target, value: replacedValue } });
                                  } else {
                                    field.onChange(e);
                                  }
                                }
                              }}
                            />
                          );
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })()}
        </Box>

        {/* Variant Section - Show only in edit mode */}
        {editForm && (
          <VariantSection
            sxContainer={styles.variantSection}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            selectedVariants={selectedVariants}
            completedVariants={completedVariants}
            variantCombinations={variantCombinations}
            variantOptionsMap={variantOptionsMap}
            availableVariantTypes={availableVariantTypes}
            productMedia={productMedia}
            variantSelectedImages={variantSelectedImages}
            openVariantImageModal={openVariantImageModal}
            currentVariantIndex={currentVariantIndex}
            isEditMode={editForm}
            setSelectedVariants={setSelectedVariants}
            setVariantOptionsMap={setVariantOptionsMap}
            setAvailableVariantTypes={setAvailableVariantTypes}
            handleRemoveVariant={handleRemoveVariant}
            handleVariantDone={handleVariantDone}
            handleRemoveCompletedVariant={handleRemoveCompletedVariant}
            handleEditCompletedVariant={handleEditCompletedVariant}
            handleDiscardCompletedVariant={handleDiscardCompletedVariant}
            editingVariantIds={editingVariantIds}
            handleSaveVariantTypes={handleSaveVariantTypes}
            handleOpenVariantImageModal={handleOpenVariantImageModal}
            handleCloseVariantImageModal={handleCloseVariantImageModal}
            handleToggleVariantImageSelection={handleToggleVariantImageSelection}
            handleSaveVariantImages={handleSaveVariantImages}
            setProductMedia={setProductMedia}
            setVariantSelectedImages={setVariantSelectedImages}
            handleDeleteVariantCombination={handleDeleteVariantCombination}
            optionTypes={optionTypes}
            handleSaveVariant={handleSaveVariant}
            handleDiscardVariant={handleDiscardVariant}
            handleVariantChange={handleVariantChange}
            modifiedVariants={modifiedVariants}
            originalVariantData={originalVariantData}
          />
        )}
        {editForm ? (
          <Button
            variant='contained'
            color='primary'
            aria-label='submit-btn'
            sx={styles.submitBtn}
            disabled={selectedVariants?.length > 0 || editingVariantIds.size > 0}
            onClick={handleSaveAndContinue}
          >
            Save & Continue
          </Button>
        ) : (
          <Button
            type='button'
            variant='contained'
            color='primary'
            aria-label='submit-btn'
            sx={styles.submitBtn}
            onClick={handleSaveButtonClick}
          >
            {BUTTON_LABELS.SAVE_PRODUCT}
          </Button>
        )}
      </Box>
      <ProductVariantsModal
        open={openVariantModal}
        onClose={() => setOpenVariantModal(false)}
        onSaveAsSingleProduct={handleSaveAsSingleProduct}
        onAddVariants={handleAddVariants}
      />
    </Box>
  );
};

export default InventoryForm;

